import * as React from "react";
import { clsx } from 'clsx';
import Icon from '../Icon/Icon';

import "./Button.scss";

type ButtonProps = {
  icon?: string,
  styleType?: string,
  type?: "button" | "submit" | "reset" | undefined;
  style?: any,
  text?: boolean,
  label?: string,
  link?: string,
  className?: string,
  reverse?: boolean,
  disabled?: boolean,
  buttonStyle?: any,
  isCircle?: boolean,
  onClick?: Function,
}

export function Button({
  icon,
  styleType = 'button',
  type = 'button',
  style = 'primary',
  text = true,
  link,
  className,
  reverse,
  label,
  disabled = false,
  buttonStyle = {},
  isCircle = false,
  onClick,
}: ButtonProps) {

  function handleClick() {
    if (onClick) onClick();
  }

  // Common props shared between button and link
  const commonProps = {
    className: clsx(`${styleType === 'link' ? `link link-${style}` : `button button-${style} `} cursor-pointer ${className}`, {
      'reverse': reverse,
      'icon-only': icon && !label,
      'text-only': style === 'text' || style === 'dark-text',
      'is-circle': isCircle,
    }),
    style: buttonStyle,
  };

  // Content for both button and link
  const content = (
    <>
      {(text && label) && <span className="button__label">{label}</span>}
      {icon && <Icon settings={{ icon_source: 'icon_name', icon_name: icon, icon_size: isCircle ? 44 : 24, alignment: 'right' }} />}
    </>
  );

  if (link) {
    return (
      <a
        href={link}
        {...commonProps}
      >
        {content}
      </a>
    );
  } else {
    return (
      <button
        type={type}
        disabled={disabled}
        onClick={() => handleClick()}
        {...commonProps}
      >
        {content}
      </button>
    );
  }
}
